import emrService from '@/apis/emr/service';
import NoDataYet from '@/components/NoDataYet';
import BaseIconSvg from '@/components/bases/BaseIconSvg';
import BaseSpin from '@/components/bases/BaseSpin';
import dayjs from 'dayjs';
import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PHRMobileMedicalRecordsItem from './PHRMobileMedicalRecordsItem';
import WrapRefresh from '../components/WrapRefresh';

const PHRMobileMedicalRecords = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { uid, bodyKey, title } = location.state;

  const keyBodyCondition =
    bodyKey === 'other'
      ? { $or: [{ 'data.icd.data.body': bodyKey }, { 'data.icd.data.body': { $exists: false } }] }
      : { 'data.icd.data.body': bodyKey };

  const {
    data: res,
    fetchNextPage,
    isFetchingNextPage,
    refetch,
  } = emrService.useGetEmrInfinite({
    type: 'healthRecord',
    uid,
    filter: bodyKey ? JSON.stringify(keyBodyCondition) : undefined,
    limit: 10,
  });

  const groupHrByMonth: Record<string, IEMRData[]> = useMemo(() => {
    let data: IEMRData[] = [];

    res?.pages?.forEach((d) => {
      const newData: IEMRData[] = d.data || [];
      data = [...data, ...newData];
    });

    return (
      data?.reduce((d: any, e) => {
        const day = dayjs(e.date);
        d[day.format('MM/YYYY')] = d[day.format('MM/YYYY')] ? [...d[day.format('MM/YYYY')], e] : [e];
        return d;
      }, {}) || {}
    );
  }, [res?.pages]);

  return (
    <WrapRefresh onRefresh={refetch}>
      <div className="overflow-hidden h-full bg-gray-2 relative">
        {/* Bắt cho tôi sự kiện scroll đến cuối trang vào thẻ này */}
        <div
          className="overflow-auto h-full"
          onScroll={(e) => {
            const element: any = e.target;
            const { scrollTop, clientHeight, scrollHeight } = element;
            if (scrollTop + clientHeight >= scrollHeight - 50) {
              !isFetchingNextPage && fetchNextPage();
            }
          }}
        >
          {Object.values(groupHrByMonth).length ? (
            Object.values(groupHrByMonth)?.map((emrs, i) => {
              const day = dayjs(emrs[0].date);
              return (
                <div key={i.toString()} className="flex flex-col">
                  {/*  ngày */}
                  <div className="w-full flex flex-row items-center text-mint-9 px-6 mt-3">
                    <BaseIconSvg src="/icons/Regular/History Clinic - icon.svg" className="wh-[16px] " />
                    <span className="cms-h5 ml-1">{day.format('MM/YYYY')}</span>
                  </div>
                  {emrs?.map((d, i: number) => {
                    return (
                      <div key={i.toString()} className={`mx-6 my-2`}>
                        <PHRMobileMedicalRecordsItem healthRecord={d} navigate={navigate} title={title} isShowIcd />
                      </div>
                    );
                  })}
                </div>
              );
            })
          ) : (
            <NoDataYet />
          )}
        </div>
        {isFetchingNextPage && (
          <div className="absolute top-0 left-0 bottom-0 right-0 bg-gray-1 bg-opacity-80 flex justify-center items-center">
            <BaseSpin />
          </div>
        )}
      </div>
    </WrapRefresh>
  );
};

export default PHRMobileMedicalRecords;
